import { render } from "./DashboardMapPopup.vue?vue&type=template&id=058be628"
import script from "./DashboardMapPopup.vue?vue&type=script&lang=js"
export * from "./DashboardMapPopup.vue?vue&type=script&lang=js"
script.render = render

export default script